import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private pendingRequestCount = 0;
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);

  readonly isLoading$ = this.loadingSubject.asObservable().pipe(distinctUntilChanged());

  show(): void {
    this.pendingRequestCount += 1;
    if (this.pendingRequestCount === 1) {
      this.loadingSubject.next(true);
    }
  }

  hide(): void {
    if (this.pendingRequestCount === 0) {
      return;
    }

    this.pendingRequestCount -= 1;
    if (this.pendingRequestCount === 0) {
      this.loadingSubject.next(false);
    }
  }
}
